import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase';
// slices
// import mailReducer from './slices/mail';
// import chatReducer from './slices/chat';
// import blogReducer from './slices/blog';
import userReducer from './slices/user';
// import productReducer from './slices/product';
import authJwtReducer from './slices/authJwt';
import settingsReducer from './slices/settings';
import localSettingsReducer from './slices/localSettings';
// import calendarReducer from './slices/calendar';
import alarmAndWarningReducer from './slices/alarmAndWarning';
import alarmAndWarningSupervisorReducer from './slices/alarmAndWarningSupervisor';
import cameraReducer from './slices/camera';
import constantsReducer from './slices/constants';
import moduleReducer from './slices/module';
import dashboardReducer from './slices/dashboard';
import locationReducer from './slices/location';
import companyReducer from './slices/company';
import faceSearchReducer from './slices/faceSearch';
import employeeReducer from './slices/employee';
import zoneReducer from './slices/zone';
import generalAnalysisReducer from './slices/generalAnalysis';
import alarmDetailReducer from './slices/alarmDetail';
import healthCheckReducer from './slices/healthCheck';
import featuresReducer from './slices/features';
import connectivityReducer from './slices/connectivity';
import EntityCount from './slices/EntityCount';
import cdnReducer from './slices/cdn';
import profileReducer from './slices/profile';
import fireFighterReducer from './slices/fireFighter';
import supervisorReducer from './slices/supervisor';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['settings']
};

// const productPersistConfig = {
//   key: 'product',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: ['sortBy', 'checkout']
// };

const authPersistConfig = {
  key: 'authJwt',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['isAuthenticated']
};

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  // mail: mailReducer,
  // chat: chatReducer,
  // blog: blogReducer,
  user: userReducer,
  alarmAndWarning: alarmAndWarningReducer,
  alarmAndWarningSupervisor: alarmAndWarningSupervisorReducer,
  entityCount: EntityCount,
  camera: cameraReducer,
  constants: constantsReducer,
  modules: moduleReducer,
  dashboard: dashboardReducer,
  location: locationReducer,
  company: companyReducer,
  faceSearch: faceSearchReducer,
  employee: employeeReducer,
  zone: zoneReducer,
  generalAnalysis: generalAnalysisReducer,
  settings: settingsReducer,
  localSettings: localSettingsReducer,
  alarmDetail: alarmDetailReducer,
  // calendar: calendarReducer,
  // product: persistReducer(productPersistConfig, productReducer),
  authJwt: persistReducer(authPersistConfig, authJwtReducer),
  healthCheck: healthCheckReducer,
  features: featuresReducer,
  connectivity: connectivityReducer,
  fireFighter: fireFighterReducer,
  cdn: cdnReducer,
  profile: profileReducer,
  supervisor: supervisorReducer
});

export { rootPersistConfig, rootReducer };
